import { render } from "./BaseActionButton.vue?vue&type=template&id=639f2fed"
import script from "./BaseActionButton.vue?vue&type=script&lang=js"
export * from "./BaseActionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__